<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 *ngIf="isEdit" class="modal-title">
      <i class="far fa-box-up"></i><ng-container>&nbsp;</ng-container
      ><ng-container i18n>Edit Last Minute Automation</ng-container>
    </h5>
    <h5 *ngIf="!isEdit" class="modal-title">
      <i class="far fa-box-up"></i><ng-container>&nbsp;</ng-container
      ><ng-container i18n>Add Last Minute Automation</ng-container>
    </h5>
    <app-page-help articleId="ftkzvedh4u"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0">
  <form [formGroup]="form" (submit)="onSubmit(form)" [formEditablePermission]="form">
    <div class="container-box p-3">
      <div class="row">
        <div class="col-lg-6">
          <mat-form-field2 class="mat-block">
            <input type="text" placeholder="Name" i18n-placeholder matInput formControlName="name" required />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('allNumbers')">
              <ng-container i18n>Name cannot be numbers alone</ng-container>.
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6">
          <mat-form-field2 i18n-matTooltip matTooltip="This automation will apply to only selected dates">
            <app-mat-daterange-input
              placeholder="Date Range"
              i18n-placeholder
              formControlName="range"
              [minDate]="minDate"
              [required]="true"
              [showQuickActions]="false"
              [ranges]="usedRange$ | async"
            ></app-mat-daterange-input>
            <mat-error *ngIf="form.get('range').touched && form.get('range').hasError('required')">
              <ng-container i18n>Date Range is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('range').hasError('overlap')">
              <ng-container i18n>Date Range is overlapping with other automation</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6">
          <app-rental-select
            i18n-placeholder
            [ctrl]="form.get('rentals')"
            [excludeSubunits]="true"
            placeholder="Rentals"
            class="mat-block"
            i18n-matTooltip
            matTooltip="Select Rental you want the Last Minute automation to apply to"
          >
          </app-rental-select>
        </div>
      </div>
    </div>

    <div class="container-box p-3 mt-3" formArrayName="windows">
      <div class="row mb-3 border-bottom" *ngFor="let item of itemsForm.controls; let i = index" [formGroupName]="i">
        <div class="col-lg-6">
          <mat-form-field2
            class="mat-block"
            i18n-matTooltip
            matTooltip="The number of nights starting from today that you want to adjust"
          >
            <input
              matInput
              type="number"
              formControlName="days_before"
              i18n-placeholder
              placeholder="Days Before"
              required
            />
            <mat-error *ngIf="item.get('days_before').touched && item.get('days_before').hasError('required')" i18n>
              Days before is required
            </mat-error>
            <mat-error
              *ngIf="item.get('days_before').hasError('positive') || item.get('days_before').hasError('integer')"
            >
              <ng-container i18n>Days before should be positive integer</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6 d-flex">
          <mat-form-field2
            class="mat-block"
            i18n-matTooltip
            matTooltip="The minimum nights requirement for the affected dates"
          >
            <input
              matInput
              type="number"
              i18n-placeholder
              formControlName="min_nights"
              placeholder="Min Nights"
              required
            />
            <mat-error *ngIf="item.get('min_nights').touched && item.get('min_nights').hasError('required')">
              <ng-container i18n>Min nights is required</ng-container>
            </mat-error>
            <mat-error
              *ngIf="item.get('min_nights').hasError('positive') || item.get('min_nights').hasError('integer')"
            >
              <ng-container i18n>Min nights should be positive integer</ng-container>
            </mat-error>
          </mat-form-field2>
          <button class="btn btn-secondary-danger align-input-row-end ml-3" (click)="onRemoveItem(i)" *ngIf="i">
            <i class="cs-icon cs-icon-trash"></i>
          </button>
        </div>
        <div class="col-lg-6">
          <mat-form-field2
            class="mat-block"
            i18n-matTooltip
            matTooltip="Click here to set a positive or negative flat fee adjustment that will be made to rates of affected dates"
          >
            <input
              matInput
              type="number"
              i18n-placeholder
              formControlName="adjust_abs"
              placeholder="Adjust Fee"
              required
            />
            <mat-error *ngIf="item.get('adjust_abs').touched && item.get('adjust_abs').hasError('required')">
              <ng-container i18n>Adjust Fee is required</ng-container>
            </mat-error>
            <mat-error *ngIf="item.get('adjust_abs').hasError('positive')">
              <ng-container i18n>Adjust Fee should be positive</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6">
          <mat-form-field2
            class="mat-block"
            i18n-matTooltip
            matTooltip="Click here to set a positive or negative percentage adjustment that will be made to rates of affected dates"
          >
            <input
              matInput
              type="number"
              formControlName="adjust_pct"
              i18n-placeholder
              placeholder="Adjust Percent"
              required
            />
            <mat-error *ngIf="item.get('adjust_pct').touched && item.get('adjust_pct').hasError('required')">
              <ng-container i18n>Adjust Percent is required</ng-container>
            </mat-error>
            <mat-error *ngIf="item.get('adjust_pct').hasError('positive')">
              <ng-container i18n>Adjust Percent should be positive</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
      <div>
        <button class="btn btn-secondary-info" (click)="onAddItem()">
          <i class="far fa-plus"></i> <ng-container i18n>Add New Item</ng-container>
        </button>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSubmit(form)"
    [disabled]="form.disabled || (1 | isReadonlyRole)"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i *ngIf="!form.disabled" class="cs-icon cs-icon-save"></i>
    <i *ngIf="form.disabled" class="far fa-spinner fa-spin"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
